/**
 * Neo3D
 *
 * Copyright (C) 2015, Loïc Le Page
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY, without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

"use strict";

module.exports = Object.freeze({
    EPSILON: 1e-6,
    EPSILON2: 1e-12,
    PI: Math.PI,
    HALF_PI: 0.5 * Math.PI,
    TWO_PI: 2.0 * Math.PI,
    RAD2DEG: 180.0 / Math.PI,
    DEG2RAD: Math.PI / 180.0,
    abs: Math.abs,
    sqrt: Math.sqrt,
    cos: Math.cos,
    acos: Math.acos,
    sin: Math.sin,
    tan: Math.tan,
    atan2: Math.atan2,
    log: Math.log,
    exp: Math.exp,
    pow: Math.pow
});
